<template>
   <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-col-12">
    <DataTable :value="accountSubHeadLists" :paginator="true" :rows="10"
    class="p-datatable-responsive p-datatable-gridlines" :filters="filters">
      <Column header="S.n" >
        <template #body="slotProps">
          {{slotProps.index+1}}
        </template>
      </Column>
            <!-- <Column header="ID"  field="id"/> -->
      <Column :sortable="true" header="Account Nature" field="natureName" filterMatchMode="contains" >
        <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['natureName']" />
        </template>
      </Column>
            <Column :sortable="true" header="Account Group" field="headName"   filterMatchMode="contains" >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['headName']" />
        </template>
            </Column>

      <Column :sortable="true" header="Account Sub Group" field="name"  filterMatchMode="contains" >
        <template #filter>
          <InputText type="text" class="p-column-filter" v-model="filters['name']" />
        </template>
      </Column>


      <Column header="Action" >
       <template #body="slotProps">
         <Button icon="pi pi-pencil" class="p-button-success p-button-sm" @click.prevent="editAccount(slotProps.data)"/>
         <Button icon="pi pi-trash" class="p-button-danger p-button-sm" v-if="!slotProps.data.isSystemOnly"  @click="openDialog(slotProps.data.id)" />
         <Button icon="pi pi-trash" class="p-button-danger p-button-sm" v-else @click="openDialog(slotProps.data.id)" disabled/>
      </template>
      </Column>
    </DataTable>
    </div>
    <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteAccSubHead"/>
  </div>
</template>
<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Dialog from '../../layout/dialog'
import InputText from 'primevue/inputtext'
import Button from 'primevue/button'
export default {
  name: 'accountSubHeadList',
  data() {
    return {
      show: false,
      dialogShow: false,
      accountSubHeadId: '',
      filters: {}
    }
  },
  components: {
    DataTable,
    Column,
    Dialog,
    InputText,
    Button
  },
  computed: {
    accountSubHeadLists() {
      return this.$store.state.accountHead.accountSubHeadLists
    }
  },
  mounted() {
    this.accountSubHeadList()
  },
  methods: {
    async accountSubHeadList() {
      try {
        this.$emit('loading-started')
        await this.$store.dispatch('loadAccountSubHeadList')
      } catch (e) {
        // Handle error
      } finally {
        this.$emit('loading-finished')
      }
    },
    async deleteAccSubHead(value) {
      if (value.trim() === '') {
        let message = {
          message: 'Delete Reason cannot be empty.',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        this.dialogShow = true
        return
      }
      let deleteRe = {
        accountSubHeadId: this.accountSubHeadId,
        deleteReason: value
      }
      try {
        let resp = await this.$store.dispatch('deleteAccSubHead', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          let message = {
            message: resp.data.message,
            messageType: 'success'
          }
          this.$emit('delete-message', message)
        } else {
          let message = {
            message: resp.data.message,
            messageType: 'warn'
          }
          this.$emit('delete-message', message)
        }
      } catch (e) {
        let message = {
          message: 'Something went wrong!!',
          messageType: 'error'
        }
        this.$emit('delete-message', message)
        return
      }

      this.closeDialog()
    },
    editAccount(data) {
      this.$emit('edit-account', data)
    },
    cancel(data) {
      // this.show = false
      this.dialogShow = false
    },
    openDialog(id) {
      this.dialogShow = true
      this.accountSubHeadId = id
    },
    closeDialog() {
      this.dialogShow = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// accountSubHeadList.vue?0badc318